import moment from "moment";
import UITooltip from "../../../common/tooltip";
import { MapPin } from "lucide-react";
import type { UIAgGridColumn } from "../../../common/agGridTable";
import { StatusBadge } from "../components/StatusBadge";
import { StatusDot } from "../components/StatusDot";
import { MarkerChips } from "../components/MarkerChips";

export const getEnablementColumns = (): UIAgGridColumn<any>[] => [
  {
    key: "markerMatrix",
    title: "ACTIVE MARKER MATRIX",
    dataIndex: "markerMatrix",
    width: 160,
    minWidth: 140,
    sorter: false,
    render: (_: any, row: any) => (
      <div className="enb-marker-cell">
        <MarkerChips matrix={row.markerMatrix ?? []} />
      </div>
    ),
  },
  {
    key: "serial",
    title: "TAG ID",
    dataIndex: "serial",
    // width: 180,
    minWidth: 100,
    flex: 1,
    sorter: true,
    render: (_: any, row: any) => (
      <div className="enb-marker-cell">
        <StatusDot status={row.success} />
        <UITooltip title={row.serial} placement="top">
          <span className="enb-tag-link">{row.serial || "-"}</span>
        </UITooltip>
      </div>
    ),
  },
  {
    key: "productUPC",
    title: "PRODUCT UPC",
    dataIndex: "productUPC",
    // width: 140,
    minWidth: 100,
    flex: 1,
    sorter: true,
    render: (_: any, row: any) => (
      <UITooltip title={row.productUPC} placement="top">
        <span className="enb-tag-link">{row.productUPC || "â€”"}</span>
      </UITooltip>
    ),
  },
  {
    key: "productName",
    title: "Product Name",
    dataIndex: "productName",
    // width: 140,
    flex: 2,
    minWidth: 180,
    defaultHidden: true,
    render: (_: any, row: any) => (
      <span className="enb-tag-link">{row.productName || ""}</span>
    ),
  },
  {
    key: "description",
    title: "Description",
    dataIndex: "description",
    // width: 140,
    flex: 2,
    minWidth: 220,
    render: (_: any, row: any) => (
      <span className="enb-tag-link">{row.productDescription || ""}</span>
    ),
  },
  {
    key: "facilityLocation",
    title: "FACILITY LOCATION",
    dataIndex: "facilityLocation",
    width: 170,
    minWidth: 120,
    sorter: true,
    defaultHidden: true,
    render: (_: any, row: any) => (
      <div className="enb-facility-cell">
        <span className="enb-facility-zone">{row.zone || "â€”"}</span>
        <span className="enb-facility-site">
          <MapPin size={10} className="enb-facility-icon" />
          {row.siteName || row.facilityLocation || "â€”"}
        </span>
      </div>
    ),
  },

  {
    key: "userName",
    title: "OPERATOR / HARDWARE",
    dataIndex: "userName",
    width: 180,
    minWidth: 150,
    sorter: true,
    defaultHidden: true,
    render: (_: any, row: any) => (
      <div className="enb-operator-cell">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          className="enb-operator-icon"
        >
          <path
            d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z"
            fill="#6b7280"
          />
        </svg>
        <div>
          <div className="enb-operator-name">{row.userName || "â€”"}</div>
          {row.hardwareName && (
            <div className="enb-hardware-name">{row.hardwareName}</div>
          )}
        </div>
      </div>
    ),
  },
  {
    key: "dateWritten",
    title: "EVENT TIMESTAMP",
    dataIndex: "dateWritten",
    width: 160,
    minWidth: 140,
    sorter: true,
    render: (field: any) => (
      <span className="enb-timestamp">
        {field ? (
          <>
            <span>{moment(field).format("M/D/YYYY")}</span>
            <span className="enb-timestamp-time">
              {moment(field).format("hh:mm A")}
            </span>
          </>
        ) : (
          ""
        )}
      </span>
    ),
  },
  {
    key: "success",
    title: "STATUS MODE",
    dataIndex: "success",
    width: 130,
    minWidth: 100,
    sorter: true,
    render: (_: any, row: any) => <StatusBadge status={row.success} />,
  },
];
